import {z as r} from 'zod';

export const omnichannelCommunicationActionDataSchema = r.object({
    chatId: r.string(),
});

export type OmnichannelCommunicationActionDataType = r.infer<typeof omnichannelCommunicationActionDataSchema>;
